import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import './select-item.styles.scss';

// MUI rend sa liste dans un `Paper` détaché du champ : c'est par là qu'on lui pose
// nos propres classes, là où le menu natif n'était pas stylable.
const MENU_PROPS = {
  classes: { paper: 'quantity-menu' },
  // Sans ces ancrages, MUI recouvre le champ avec la liste centrée sur l'option
  // choisie ; on la veut déroulée sous le champ.
  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
  transformOrigin: { vertical: 'top', horizontal: 'left' }
};

const SelectItem = ({ product, value, onSelect }) => {
  const prices = product.prices ?? [];
  // La boutique affiche autant de sélecteurs que de vignettes : un identifiant
  // écrit en dur n'y rattacherait plus rien à rien.
  const labelId = `quantity-label-${product.id}`;

  // Invite courte : sur une vignette de boutique, le champ ne fait qu'environ
  // 200px et une phrase plus longue s'y ferait tronquer.
  const renderValue = (selected) =>
    prices.find((item) => item.value === selected)?.label ??
    'Choisir une quantité';

  return (
    // Un `<label>` enveloppant renverrait le clic à l'input caché de MUI, ce qui
    // rouvrirait la liste aussitôt refermée : l'intitulé est rattaché par `labelId`.
    <div className="quantity-field">
      <span className="quantity-label" id={labelId}>
        Quantité
      </span>

      <Select
        className="quantity-select"
        labelId={labelId}
        // La chaîne vide est la valeur « rien de choisi » attendue par MUI ;
        // l'état du parent, lui, part de 0.
        value={value || ''}
        onChange={(event) => onSelect(event.target.value)}
        displayEmpty
        renderValue={renderValue}
        MenuProps={MENU_PROPS}
      >
        {prices.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

export default SelectItem;
